import { type FC, useEffect, useState } from 'react';
import classnames from 'classnames';
import { PinchZoom } from 'dibs-pinch-zoom-swipe';

import styles from './NftPdpZoomModalMobile.scss';

const PINCH_MESSAGE_HIDE_TIMEOUT = 750;
const PINCH_MESSAGE_TRANSITION_DURATION = 500;

const useMobilePrompt = (isOpen: boolean): boolean => {
    const [showMessage, setShowMessage] = useState(false);
    useEffect(() => {
        if (isOpen) {
            const showMessageTimeOut = setTimeout(() => setShowMessage(true), 0);
            const hideMessageTimeOut = setTimeout(
                () => setShowMessage(false),
                PINCH_MESSAGE_HIDE_TIMEOUT + PINCH_MESSAGE_TRANSITION_DURATION
            );

            return () => {
                clearTimeout(showMessageTimeOut);
                clearTimeout(hideMessageTimeOut);
            };
        }
        return () => {};
    }, [isOpen]);
    return showMessage;
};

export const NftPdpZoomModalMobile: FC<{
    isOpen: boolean;
    isMobile: boolean;
    src?: string;
    alt?: string;
}> = ({ isOpen, src, alt }) => {
    const show = useMobilePrompt(isOpen);
    return (
        <>
            <PinchZoom enabled>
                <img className={styles.img} alt={alt} src={src} srcSet={undefined /* TODO */} />
            </PinchZoom>
            <div
                className={classnames(styles.mobilePrompt, {
                    [styles.showMobilePrompt]: show,
                })}
            >
                Pinch to Zoom
            </div>
        </>
    );
};
